import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { BasicItemDetailsHeader } from '@components/basic'
import ArticlesListModal from './ArticlesListModal.vue';
import PlacementsListModal from '@components/places/PlacementsListModal.vue';
import PackagesModal from '@components//packages/PackagesModal.vue';
import useModals from '@/composable/useModals';
import { TCombination } from '@/const/types/combination';
import { TPackage } from '@/const/types/package';
import { IAggregatedPlacement } from '@/const/types/placement';

interface Props {
    hasCombinations: boolean;
    hasPackages: boolean;
    hasPlacements: boolean;
    combinations: TCombination[];
    packages: TPackage[];
    placements: IAggregatedPlacement[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleScannedDetails',
  props: {
    hasCombinations: { type: Boolean },
    hasPackages: { type: Boolean },
    hasPlacements: { type: Boolean },
    combinations: null,
    packages: null,
    placements: null
  },
  setup(__props: any) {

const props = __props as {
    hasCombinations: boolean;
    hasPackages: boolean;
    hasPlacements: boolean;
    combinations: TCombination[];
    packages: TPackage[];
    placements: IAggregatedPlacement[];
};



const MODALS = {
    COMBINATIONS: 'combinations',
    PLACEMENTS: 'placements',
    PACKAGES: 'packages',
} as const;

const {
    isModalOpen,
    closeModal,
    openModal,
} = useModals({ types: MODALS });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BasicItemDetailsHeader), {
      "has-combinations": __props.hasCombinations,
      "has-packages": __props.hasPackages,
      "has-placements": __props.hasPlacements,
      onOpenCombinations: _cache[0] || (_cache[0] = ($event: any) => (_unref(openModal)(_unref(MODALS).COMBINATIONS))),
      onOpenPackages: _cache[1] || (_cache[1] = ($event: any) => (_unref(openModal)(_unref(MODALS).PACKAGES))),
      onOpenPlacements: _cache[2] || (_cache[2] = ($event: any) => (_unref(openModal)(_unref(MODALS).PLACEMENTS)))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["has-combinations", "has-packages", "has-placements"]),
    _renderSlot(_ctx.$slots, "details-list"),
    (__props.hasCombinations)
      ? (_openBlock(), _createBlock(ArticlesListModal, {
          key: 0,
          articles: props.combinations,
          "is-open": _unref(isModalOpen)(_unref(MODALS).COMBINATIONS),
          "article-name": "Combination",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_unref(closeModal)(_unref(MODALS).COMBINATIONS)))
        }, null, 8, ["articles", "is-open"]))
      : _createCommentVNode("", true),
    (__props.hasPlacements)
      ? (_openBlock(), _createBlock(PlacementsListModal, {
          key: 1,
          placements: props.placements,
          "is-open": _unref(isModalOpen)(_unref(MODALS).PLACEMENTS),
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(closeModal)(_unref(MODALS).PLACEMENTS)))
        }, null, 8, ["placements", "is-open"]))
      : _createCommentVNode("", true),
    (__props.hasPackages)
      ? (_openBlock(), _createBlock(PackagesModal, {
          key: 2,
          packages: props.packages,
          "is-open": _unref(isModalOpen)(_unref(MODALS).PACKAGES),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_unref(closeModal)(_unref(MODALS).PACKAGES)))
        }, null, 8, ["packages", "is-open"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})